import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageFormComponent } from '../image-form/image-form.component';
import {Image, ImageService} from '../../../common/services';
import {typeEvents} from '../../../common/enum/type-events';
import {PubSubService} from '../../../common/services/pub-sub.service';

@Component({
  selector: 'p8-bdc-image-edit',
  templateUrl: './image-edit.component.html',
  styleUrls: ['./image-edit.component.scss']
})
export class ImageEditComponent implements OnInit {
  @ViewChild(ImageFormComponent) imageFormComponent: ImageFormComponent;

  image: Image;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private imageService: ImageService,
    private pubSubService: PubSubService
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if ('id' in params) {
        this.imageService.get(params['id']).subscribe((img: Image) => {
          if (img && img.description === 'null') {
            img.description = null;
          }
          this.image = img;
          console.log(this.image);
        });
      }
    });
  }

  onSubmit() {
    this.imageFormComponent.patch(this.image.id).subscribe(page => {
      this.pubSubService.publish(typeEvents.imageSaved, 'Les informations de l\'image ont bien été modifiées');
      // this.router.navigate(['..'], {relativeTo: this.activatedRoute});
    });
  }

  onCancel() {
    this.router.navigate(['../..'], {relativeTo: this.activatedRoute});
  }
}
